import settings from './settings';
//import FlowableAPI  from 'flowable-js-api/lib/index';

//const flowableAPI = require('flowable-js-api/lib/index')(settings); 
const flowableAPI = require('./client')(settings); 

const ApiUtils = {
    getProcessDefinitions(){
        return flowableAPI.processInstances.getProcessInstances({size:100, includeProcessVariables: true});
    }
};

export default ApiUtils;
